import { API } from 'aws-amplify';

class CertificatesService {
   getCertificates = async (airlineCode) => {
          var ReturnObj = [];
      
      await API.get('IAPI', 'Certificates/getCertificates/', {
         queryStringParameters: {
            AirlineCode: airlineCode
         }
      }).then((res) => {
         ReturnObj = res;
         return res;
      }).catch((error) => {
         return error;
      }
      );
      return ReturnObj;
   }

   createCertificate = async (values) => {
      var ReturnObj = {};
      var myInit = {
         body: {
            hostName: values.hostName,
            ipAddress: values.ipAddress            
         }
      }
      await API.post('IAPI', 'Certificates/createCertificate/', myInit)
         .then((res) => {            
            ReturnObj = res;
                                 
            return res;
         }).catch((error) => {
            return error;
         }
         );

      return ReturnObj;
   }

   deleteCertificate = async (hostNameToDelete) => {
      var ReturnObj = {};
      
      await API.get('IAPI', 'Certificates/deleteCertificate/', {
         queryStringParameters: {
            hostName: hostNameToDelete
         }
      }).then((res) => {         
         ReturnObj = res;         
         return res;
      }).catch((error) => {
         return error;
      }
      );
      return ReturnObj;
   }    
   
   downloadPrivatekey = async (airlineCode) => {            
      var ReturnObj = [];
      
      await API.get('IAPI', 'Certificates/downloadPrivatekey/', {
         queryStringParameters: {
            airlineCode: airlineCode
         }
      }).then((res) => {            
         ReturnObj = res;                            
         return res;
      }).catch((error) => {         
         return error;
      });
      return ReturnObj;
   }

   downloadPemkey = async (hostName) => {            
      var ReturnObj = [];
      
      await API.get('IAPI', 'Certificates/downloadPemkey/', {
         queryStringParameters: {
            hostName: hostName
         }
      }).then((res) => {         
         ReturnObj = res;
         return res;
      }).catch((error) => {         
         return error;
      });
      return ReturnObj;
   }
}

export default new CertificatesService();